<script>
    import { CarreraDTO } from "../../api/DTOS/Carrera.dto.js";
    import { carrerasBasicas } from "../../MainStore.js";

    let editando = false;
    let carrera = new CarreraDTO();

    const handleCancelar = () => {
        editando = false;
        carrera = new CarreraDTO();
    };
    const handleClickAgregarGuardar = async () => {
        if (editando) {
            await carrerasBasicas.actualizar(carrera);
        } else {
            await carrerasBasicas.agregar(carrera);
        }
        editando = false;
        carrera = new CarreraDTO();
    };
    const handleEditarCarrera = indexCarrera => {
        carrera = $carrerasBasicas[indexCarrera];
        editando = true;
    };
    const handleEliminarCarrera = async () => {
        await carrerasBasicas.borrar(carrera.id);

        editando = false;
        carrera = new CarreraDTO();
    };
</script>

<div class="card">
    <div class="card-header">
        Carreras
    </div>
    <div class="card-body">
        <div class="row row-agregar-carrera">
            <div class="col-2">
                Resolucion
            </div>
            <div class="col-6">
                <input placeholder="Resolucion" class="form-control" bind:value={carrera.resolucion} />
            </div>
        </div>
        <div class="row mt-2 row-agregar-carrera">
            <div class="col-2">
                Nombre carrera
            </div>
            <div class="col-6">
                <input placeholder="Nombre carrera" class="form-control" bind:value={carrera.nombre}/>
            </div>
        </div>
        <div class="row justify-content-end mt-2">
            <div class="col text-right">
                {#if editando}
                    <button class="btn btn-raised btn-danger mr-2" on:click={handleEliminarCarrera}>Eliminar</button>
                {/if}
                <button class="btn btn-raised btn-secondary mr-2" on:click={handleCancelar}>Cancelar</button>
                <button class="btn btn-raised btn-success" on:click={handleClickAgregarGuardar}>{editando ? "Guardar" : "Agregar"}</button>
            </div>
        </div>
        <table class="table mt-4 tabla-item-seleccionable">
            <thead>
                <tr>
                    <th scope="col">Nombre</th>
                    <th scope="col">Resolucion</th>
                </tr>
            </thead>
            <tbody>
                {#each $carrerasBasicas as carrera, index}
                    <tr on:click={() => { handleEditarCarrera(index) }}>
                        <td>{carrera.nombre}</td>
                        <td>{carrera.resolucion}</td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
</div>